import {
    AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay,
    Button, HStack, Text, useDisclosure, VStack
} from "@chakra-ui/react"
import { useEffect, useRef } from "react"
import { defaultSelectData, useSelectedItemAlertContext, AL_CANCEL, AL_DELETE, AL_DISCLAIM } from '../../context/selectedItemAlertContext'
import { BsCheck, BsX } from "react-icons/bs";

const DialogConfirm = ({ data, deleteHandle }) => {
    const { onClose, isOpen, onOpen } = useDisclosure()
    const { setItemData } = useSelectedItemAlertContext()
    const cancelRef = useRef()

    const AlertHeader = () => {
        let header = ''
        if (data?.type === AL_CANCEL) header = `ยืนยันการยกเลิกข้อมูล ${data?.header}`
        else if (data?.type === AL_DELETE) header = `ยืนยันการลบข้อมูล ${data?.header}`
        else if (data?.type === AL_DISCLAIM) header = `ยืนยันการสละสิทธิคิว ${data?.header}`

        return (<Text>{header}</Text>)
    }

    const AlertBody = () => {
        let body = ''
        if (data?.type === AL_CANCEL) body = `ยกเลิกข้อมูลนี้`
        else if (data?.type === AL_DELETE) body = `ลบข้อมูลนี้`
        else if (data?.type === AL_DISCLAIM) body = `สละสิทธิคิวนี้`

        return (
            <VStack align="start">
                <Text>คุณต้องการ <Text as="span" fontWeight="bold" color="red">{body}</Text> ใช่หรือไม่</Text>
                <Text fontWeight="bold">{data?.body}</Text>
            </VStack>
        )
    }

    const openModal = useRef()
    openModal.current = () => {
        if ((data?.type === AL_CANCEL || data?.type === AL_DELETE || data?.type === AL_DISCLAIM) && data?.id) onOpen()
    }

    useEffect(() => {
        openModal.current()
    }, [data])

    const onCloseHandle = () => {
        setItemData(defaultSelectData)
        onClose()
    }

    const onAcceptHandle = async () => {
        if (data?.type === AL_DELETE || data?.type === AL_DISCLAIM) {
            await deleteHandle(data?.id)
        }

        onCloseHandle()
    }

    return (
        <AlertDialog
            isOpen={isOpen}
            leastDestructiveRef={cancelRef}
            onClose={onCloseHandle}
            size="xl"
        >
            <AlertDialogOverlay>
                <AlertDialogContent>
                    <AlertDialogHeader>
                        <AlertHeader />
                    </AlertDialogHeader>
                    <AlertDialogBody>
                        <AlertBody />
                    </AlertDialogBody>
                    <AlertDialogFooter>
                        <HStack>
                            <Button ref={cancelRef} leftIcon={<BsX />} onClick={onCloseHandle}>ไม่ใช่</Button>
                            <Button leftIcon={<BsCheck />} colorScheme="red" onClick={onAcceptHandle}>ตกลง</Button>
                        </HStack>
                    </AlertDialogFooter>
                </AlertDialogContent>
            </AlertDialogOverlay>
        </AlertDialog>
    )
}

export default DialogConfirm
